<template>
  <div id="main-wrapper">
    <div v-if="success">
      <div class="mfp-bg animated zoomIn mfp-ready"></div>
      <div class="mfp-wrap mfp-close-btn-in mfp-auto-cursor animated zoomIn mfp-ready" tabindex="-1" style="overflow: hidden auto;">
        <div class="mfp-container mfp-s-ready mfp-inline-holder">
          <div class="mfp-content">
            <div id="upload-confirm" class="white-popup-block popup-content popup-small">
              <div class="content t-white t-left">
                <p>{{$t("support_page.success_message")}}</p>
              </div>
              <div class="btn-holder t-center">
                <a href="#" class="btn btn-lblue close-popup" @click.prevent="success = false">{{$t("support_page.ok")}}</a>
              </div>
              <button title="Close (Esc)" type="button" class="mfp-close" @click.prevent="success = false">×</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="content-container profile-page personal-details request-call support-page"
    >
      <div class="page-wrap">
        <div class="page-content clearfix">
          <div class="main-content f-left">
            <div class="title-holder wow fadeInLeft">
              <h4>{{$t("support_page.support")}}</h4>
            </div>
            <div class="support-nav wow fadeInLeft">
              <ul>
                <li class="active">
                  <router-link to="/support">{{$t("support_page.create_req")}}</router-link>
                </li>
                <li>
                  <router-link to="/open-tickets">{{$t("support_page.open_tickets")}}</router-link>
                </li>
                <li>
                  <router-link to="/closed-tickets">{{$t("support_page.closed_tickets")}}</router-link>
                </li>
              </ul>
            </div>
            <div class="content-holder wow fadeInLeft">
              <div class="row-sec">
                <div class="form-holder" v-if="this.store.showOTP">
                  <div class="form-group">
                    <h4>{{$t("support_page.otp_msg")}}</h4>
                    <Form @submit="confirmSupportTicket" v-if="!success">
                      <ul class="clearfix">
                        <li class="">
                          <label for="">{{$t("support_page.otp")}} <span style="color: #d43737">*</span></label>
                          <Field
                            class="form-control"
                            name="otp"
                            rules="required|numeric|min:6|max:6"
                            v-model="otp"
                          />
                          <ErrorMessage name="otp" />
                        </li>
                      </ul>
                      <div class="btn-holder t-center">
                        <button type="submit" class="btn btn-blue popup-link-holder">
                          {{$t("support_page.submit")}}
                        </button>
                      </div>
                    </Form>
                  </div>
                </div>
                <div class="form-holder" v-else>
                  <Form @submit="createSupportTicket">
                    <ul class="clearfix">
                      <li class="">
                        <label for="">{{$t("support_page.reason")}}<span style="color: #d43737">*</span></label>
                        <Field
                          class="form-control"
                          @change="updateNote"
                          as="select"
                          name="reason"
                          rules="required"
                          v-model="form.reason"
                        >
                          <option value="" disabled>{{$t("support_page.select_a_reason")}}</option>
                          <option
                            v-for="reason of store.ticketReasons"
                            :value="reason.id"
                            :key="reason.id"
                          >
                            {{ reason.title }}
                          </option>
                        </Field>
                        <ErrorMessage name="reason" />
                      </li>
                      <li class="">
                        <label for="">{{$t("support_page.trading_id")}}
                          <!-- <span style="color: #d43737">*</span> --></label>
                        <Field
                          class="form-control"
                          as="select"
                          name="account"
                          v-model="form.account_id"
                        >
                          <option value="" disabled>
                            {{$t("support_page.select_trading_account")}}
                          </option>
                          <!-- <option
                            v-for="account of store.tradingAccounts.records"
                            :value="account.account_id"
                            :key="account.account_id"
                          >
                            {{ account.account_id }} ({{
                              account.demo_live == "1" ? "Live" : "Demo"
                            }})
                          </option> -->
                          <optgroup label="Demo MT4">
                              <option :value="list.account_id" v-for="list,index in MergeAcc('0','MT4')" :key ="index" >{{list.account_id}}</option>
                            </optgroup>
                            <optgroup label="Demo MT5">
                              <option :value="list.account_id" v-for="list,index in MergeAcc('0','MT5')" :key ="index" >{{list.account_id}}</option>
                            </optgroup>
                            <optgroup label="Live MT4">
                              <option :value="list.account_id" v-for="list,index in MergeAcc('1','MT4')" :key ="index" >{{list.account_id}}</option>
                            </optgroup>
                            <optgroup label="Live MT5">
                              <option :value="list.account_id" v-for="list,index in MergeAcc('1','MT5')" :key ="index" >{{list.account_id}}</option>
                            </optgroup>
                            <optgroup label="Live ZTP">
                            <option :value="list.account_id" v-for="list,index in MergeAcc('1','ZTP')" :key ="index" >{{list.account_id}}</option>
                          </optgroup>
                        </Field>
                        <!-- <ErrorMessage name="account" /> -->
                      </li>
                      <li class="">
                        <label for="">{{$t("support_page.subject")}} <span style="color: #d43737">*</span></label>
                        <Field
                          class="form-control"
                          name="subject"
                          rules="required"
                          v-model="form.subject"
                        />
                        <ErrorMessage name="subject" />
                      </li>
                      <li class="" v-if="form.reason == 196">
                        <label for="">{{$t("support_page.trade_order_id")}} <span style="color: #d43737">*</span></label>
                        <Field
                          class="form-control"
                          name="order id"
                          rules="required"
                          v-model="form.order_id"
                        />
                        <ErrorMessage name="order id" />
                      </li>
                      <li class="" v-if="form.reason == 196">
                        <label for="">{{$t("support_page.time_of_trade_opening")}} <span style="color: #d43737">*</span></label>
                        <Field
                          class="form-control"
                          name="opening time"
                          rules="required"
                          v-model="form.opening_time"
                        />
                        <ErrorMessage name="opening time" />
                      </li>
                      <li class="" v-if="form.reason == 196">
                        <label for="">{{$t("support_page.time_of_trade_closing")}} <span style="color: #d43737">*</span></label>
                        <Field
                          class="form-control"
                          name="closing time"
                          rules="required"
                          v-model="form.close_time"
                        />
                        <ErrorMessage name="closing time" />
                      </li>
                      <li class="" v-if="form.reason == 196">
                        <label for="">{{$t("support_page.instrument_traded")}} <span style="color: #d43737">*</span></label>
                        <Field
                          class="form-control"
                          name="instrument traded"
                          rules="required"
                          v-model="form.instrument_trade"
                        />
                        <ErrorMessage name="instrument traded" />
                      </li>
                      <li class="" v-if="form.reason == 196">
                        <label for="">
                          {{$t("support_page.type_of_trade")}}
                          <span style="color: #d43737">*</span>
                        </label>
                        <Field
                          class="form-control"
                          as="select"
                          name="trade type"
                          v-model="form.trade_type"
                          rules="required"
                        >
                          <option value="" disabled>
                            {{$t("support_page.select_trade_type")}}
                          </option>
                          <option
                            v-for="value,key in static_vars.trade_type"
                            :value="key"
                            :key="key"
                          >
                            {{ value }}
                          </option>
                        </Field>
                        <ErrorMessage name="trade type" />
                      </li>
                      <li class="" v-if="form.reason == 196">
                        <label for="">{{$t("support_page.details_of_the_issue")}}<span style="color: #d43737">*</span></label>
                        <Field
                          class="form-control"
                          name="detail issue"
                          rules="required"
                          v-model="form.issue_detail"
                        />
                        <ErrorMessage name="detail issue" />
                      </li>
                      <li class="" v-if="form.reason == 196">
                        <label for="">{{$t("support_page.refund_claim_amount")}}<span style="color: #d43737">*</span></label>
                        <Field
                          class="form-control"
                          name="claim amount"
                          rules="required"
                          v-model="form.refund_claim_amount"
                        />
                        <ErrorMessage name="claim amount" />
                      </li>
                      <li class="">
                        <label for="">{{$t("support_page.message")}} <span style="color: #d43737">*</span></label>
                        <Field
                          v-slot="{ field }"
                          rows="8"
                          name="message"
                          rules="required|min:10"
                          v-model="form.message"
                        >
                          <textarea
                            v-bind="field"
                            rows="8"
                            cols="80"
                          ></textarea>
                        </Field>
                        <ErrorMessage name="message" /><br/>
                        <span v-if="userNote"><b>{{$t("support_page.note")}}: </b>{{ userNote }}</span>
                      </li>
                      <li class="">
                        <label for="">
                          {{$t("support_page.file_attachments")}}
                          <span style="color: #d43737">*</span>
                        </label>
                        <div class="file-upload">
                          <div class="file-upload-select">
                            <input
                              type="file"
                              name="file-upload-input"
                              accept="image/*,application/pdf"
                              @change="setImage"
                              class="file-upload-input"
                              id="file-upload"
                            />
                            <div class="file-select-name">
                              {{ attachment.name }}
                            </div>
                            <div class="file-select-button">
                              <img
                                src="assets/images/file-upload-icon.png"
                                alt=""
                              />
                            </div>
                          </div>
                        </div>
                        <div class="note">
                          <p>
                            <span style="color: #f14c52">*</span> {{$t("support_page.file_size_msg")}} <br />
                            <span style="color: #f14c52">*</span> {{$t("support_page.file_format_msg")}} <br />
                          </p>
                          <p><strong>{{$t("support_page.lowercase_note")}} : </strong>{{$t("support_page.note_desc")}}</p>
                        </div>
                      </li>
                    </ul>
                    <div class="btn-holder t-center">
                      <button type="submit" class="btn btn-blue popup-link-holder">
                        {{$t("support_page.create_support_request")}}
                      </button>
                    </div>
                  </Form>
                </div>
              </div>
            </div>
            <div class="img-holder t-center wow fadeInRight va-top">
              <img src="assets/images/supp-img.png" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useMainStore } from "@/store";
import { Form, Field, ErrorMessage } from "vee-validate";

export default {
  setup() {
    const store = useMainStore();
    return { store };
  },
  data() {
    return {
      otp: "",
      userNote: null,
      success: false,
      form: {
        reason: "",
        subject: "",
        account_id: "",
        message: "",
        order_id : "",
        opening_time : "",
        close_time : "",
        instrument_trade : "",
        trade_type : "",
        issue_detail : "",
        refund_claim_amount : ""
      },
      attachment: {},
    };
  },
  computed: {
    availableLeverages() {
      return this.static_vars.leverages.filter(
        (i) => i.value != this.store.lastSelectedAccount.leverage
      );
    },
  },
  mounted() {
    // this.form.account_id = this.store.lastSelectedAccount.account_id;
    if (this.$route.query.title) {
      this.form.reason = 8;
    }
    if (this.$route.query.package) {
      this.form.subject = `VPS ${this.$route.query.package} package subscription`;
      this.form.message = `I want to avail your VPS services for ${this.$route.query.package} package`;
    }
    if(this.$route.query.from && this.$route.query.from == 'pamm-acct'){
        this.form.reason = 54
    }
    if(this.store.showOTP){
        this.store.$patch({ showOTP : false})
    }
  },
  components: {
    Form,
    Field,
    ErrorMessage,
  },
  methods: {
    MergeAcc(acc_type,platform){
        let demoMT4 = this.store.tradingAccounts.records.filter(i => i.demo_live == acc_type && i.platform == platform).map(val => val)
        return demoMT4 || []
    },
    createSupportTicket() {
      let formData = new FormData();
      if (this.attachment.name) {
        formData.append("document", this.attachment);
      }
      const reasonText = this.store.ticketReasons[this.form.reason];
      formData.append("subject", this.form.subject);
      formData.append("text", this.form.message);
      formData.append("reason", this.form.reason);
      formData.append("reason_text", reasonText.title);
      formData.append("title", this.form.reason);
      formData.append("title_text", reasonText.title);
      formData.append("account_id", this.form.account_id);
      this.store.createSupportTicket(formData, true,this);
    },
    confirmSupportTicket() {
      let formData = {
        otp: this.otp,
        trans_id: this.store.trans_id,
      };
      this.store.confirmSupportTicket(formData, true, this);
    },
    setImage(e) {
      this.attachment = e.target.files[0];
    },
    updateNote(e) {
      if (e.target.value == "5") {
        this.userNote =
          "Please mention the Deposit method, Payment Reference No. and Attach the transaction receipt if available";
      } else if (e.target.value == "194") {
        this.userNote = "Please attach screenshot of the issue you are facing";
      } else if (e.target.value == "196") {
        this.userNote = "Please mention Trading Account Number & Order ID ";
      } else {
        this.userNote = null;
      }
    },
  },
};
</script>
